/* import __COLOCATED_TEMPLATE__ from './open-conversation.hbs'; */
/* RESPONSIBLE TEAM: team-inbox-experience */
import templateOnlyComponent from '@ember/component/template-only';
import { type MacroActionComponentArgs } from 'embercom/lib/inbox2/bulk-action-types';

interface Signature {
  Element: HTMLDivElement;
  Args: MacroActionComponentArgs;
}

const OpenConversation = templateOnlyComponent<Signature>();
export default OpenConversation;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::Composer::MacroActions::OpenConversation': typeof OpenConversation;
    'inbox2/composer/macro-actions/open-conversation': typeof OpenConversation;
  }
}
